import * as ABCya from '@abcya/abcya_phaser';
import ABCyaLib from '@abcya/abcya_lib';
import gameData from '../../gameData';
import { customConvertToButton, menuUI } from './menuUI';
import { displayDonuts } from './displayQuestionParts';
import sKey from '../../SoundAssetKeys';
import { makeDonutStart } from '../makeADonut/makeDonutStart';


export function createTitle(scene)
{
    const centerOffset = 82;
    const miscShadow = ABCya.Images.addImage(510, 314 + centerOffset, "Title Screen/Logo_Shadow",scene).setAlpha(0);
    const donut = ABCya.Images.addImage(510, 308 + centerOffset, "Title Screen/Logo_Donut",scene).setAlpha(0);
    const play = ABCya.Images.addImage(514, 642, "Title Screen/Btn_Play",scene).setAlpha(0);//set interactive in raiseAll();
    const diff_D = ABCya.Images.addImage(128, 438 + centerOffset, "Title Screen/Different_D",scene).setAlpha(0);
    const diff_I = ABCya.Images.addImage(211, 445 + centerOffset, "Title Screen/Different_I",scene).setAlpha(0);
    const diff_F1 = ABCya.Images.addImage(287, 437 + centerOffset, "Title Screen/Different_F1",scene).setAlpha(0);
    const diff_F2 = ABCya.Images.addImage(378, 443 + centerOffset, "Title Screen/Different_F2",scene).setAlpha(0);
    const diff_E1s = ABCya.Images.addImage(475, 446 + centerOffset, "Title Screen/Different_E1_Shadow",scene).setAlpha(0);
    const diff_E1 = ABCya.Images.addImage(472, 438 + centerOffset, "Title Screen/Different_E1",scene).setAlpha(0);
    const diff_Rs = ABCya.Images.addImage(572, 446 + centerOffset, "Title Screen/Different_R_Shadow",scene).setAlpha(0);
    const diff_R = ABCya.Images.addImage(572, 437 + centerOffset, "Title Screen/Different_R",scene).setAlpha(0);
    const diff_E2 = ABCya.Images.addImage(664, 438 + centerOffset, "Title Screen/Different_E2",scene).setAlpha(0);
    const diff_N = ABCya.Images.addImage(769, 438 + centerOffset, "Title Screen/Different_N",scene).setAlpha(0);
    const diff_T = ABCya.Images.addImage(886, 437 + centerOffset, "Title Screen/Different_T",scene).setAlpha(0);
    const and = ABCya.Images.addImage(513, 308 + centerOffset, "Title Screen/Logo_And",scene).setAlpha(0);
    const same_Sh = ABCya.Images.addImage(352, 244 + centerOffset, "Title Screen/Same_S_Shadow",scene).setAlpha(0);
    const same_S = ABCya.Images.addImage(350, 236 + centerOffset, "Title Screen/Same_S",scene).setAlpha(0);
    const same_As = ABCya.Images.addImage(442, 170 + centerOffset, "Title Screen/Same_A_Shadow",scene).setAlpha(0);
    const same_A = ABCya.Images.addImage(442, 162 + centerOffset, "Title Screen/Same_A",scene).setAlpha(0);
    const same_Ms = ABCya.Images.addImage(575, 161 + centerOffset, "Title Screen/Same_M_Shadow",scene).setAlpha(0);
    const same_M = ABCya.Images.addImage(575, 153 + centerOffset, "Title Screen/Same_M",scene).setAlpha(0);
    const same_Es = ABCya.Images.addImage(668, 247 + centerOffset, "Title Screen/Same_E_Shadow",scene).setAlpha(0);
    const same_E = ABCya.Images.addImage(675, 241 + centerOffset, "Title Screen/Same_E",scene).setAlpha(0);

    const shadows = [miscShadow,diff_E1s,diff_Rs,same_Sh,same_As,same_Ms,same_Es];
    const sameLetters = [same_S,same_A,same_M,same_E];
    const diffLetters = [diff_D,diff_I,diff_F1,diff_F2,diff_E1,diff_R,diff_E2,diff_N,diff_T];

    //let all = [diff_D,diff_I,diff_F1,diff_F2,diff_E1,diff_R,diff_E2,diff_N,diff_T,same_S,same_A,same_M,same_E,and,donut];
    let all = shadows.concat(sameLetters);
    all = all.concat(diffLetters);
    all.push(donut);
    all.push(and);

    const timeline = scene.tweens.createTimeline();

    donutRollIn(donut,800,0,Phaser.Math.Easing.Quadratic.Out,false,timeline,()=>{scene.custSound.playSoundCustom(sKey._title_donut_enter)});
    sameFall(sameLetters,timeline);
    andPop(and,timeline);
    differentFadeIn(diffLetters,timeline);
    raiseAll(all,play,timeline);//Due to timing issues, play button is setinteractive in this function
    shadowFadeIn(shadows,timeline);

    timeline.play();

    const currentEnvironment = ABCyaLib.Environment.instance.environment;
     if (currentEnvironment != ABCyaLib.Environment.ENVIRONMENTS.production &&
        currentEnvironment != ABCyaLib.Environment.ENVIRONMENTS.unknown)

     {
         scene._toggleButton = scene.add.rectangle(scene.sys.canvas.width / 2, 0, 400, 100, 0xffffff, 0).setOrigin(0.5, 0);
         scene._toggleButton.setInteractive();
         scene._toggleButton.on('pointerdown',()=>{
             devPopUp(scene,all,play);
         });
    }
}

function devPopUp(scene,all,play)
{
    const rect = scene.add.rectangle(0,0,200,768,0x000000,.75).setOrigin(0,0);
    const makeA = scene.add.text(10,345,"Make A Donut").setDepth(9);

    makeA.setInteractive();
    makeA.on('pointerdown',()=>{
        makeA.removeInteractive();
        ABCya.Tweens.addTween(all,500,{y:-1000},Phaser.Math.Easing.Quadratic.In,()=>{
            scene._toggleButton.destroy();
            rect.destroy();
            makeA.destroy();
            makeDonutStart(scene);
            menuUI(scene,5,36);
        });
        ABCya.Tweens.addTween(play,300,{y:900},Phaser.Math.Easing.Quadratic.In);
    });
}

function setUpPlayButton(play,all)
{
    customConvertToButton(play);
    play.on('pointerdown',()=>{
        play.disableInteractive();
        allTweenOut(play,all);
        play.scene.custSound.playSoundCustom(sKey._title_donut_leave);
        //play.scene.custSound.playSoundCustom(sKey._click_select_donuts);
    })
}

function allTweenOut(play,all)
{
    const scene = play.scene;
    ABCya.Tweens.addTween(all,500,{y:-1000},Phaser.Math.Easing.Quadratic.In,()=>{
        displayDonuts(gameData.layouts[gameData.questionNum], scene);
        menuUI(scene);
    });
    ABCya.Tweens.addTween(play,300,{y:900},Phaser.Math.Easing.Quadratic.In);
}

export function donutRollIn(object,timeTaken,delay,ease = Phaser.Math.Easing.Linear,OffLeft = false,timeline,start)
{
    let Rotation;
    let Distance;

    Distance = 6.283 * object.width/2;
    Rotation = Distance/(object.width/2);
    if (OffLeft != true)
    {
        Distance = Distance * -1;
    }
    else
    {
        Rotation = Rotation * -1;
    }

    timeline.add({
        targets:object,
        delay:delay,
        alpha:{start:1,to:1},
        x: {start:object.x + Distance, to: object.x},
        rotation: Rotation,
        duration: timeTaken,
        ease:ease,
        onStart:()=>{
            object.setAlpha(1);
            start();

        }

    });

    //const tween = ABCya.Tweens.addTween(object,TimeTaken,{rotation: Rotation, x: {start:object.x + Distance, to: object.x},delay:delay},Ease);
    //tween.on('start',()=>{
    //    object.setAlpha(1);
    //})
}

function andPop(object,timeline)
{
    timeline.add({
        targets:object,
        offset:"-=80",
        alpha:{start:1,to:1},
        scale:{start:0,to:1},
        duration: 500,
        ease:Phaser.Math.Easing.Bounce.Out,
        onStart:()=>{
            object.setAlpha(1);
            object.scene.custSound.playSoundCustom(sKey._appear);
        }
    });
}

function sameFall(letters,timeline)
{
    const scene = letters[0].scene;
    timeline.add({
        targets:letters[0],
        offset:`-=${300}`,
        y: {start:"-=800", to: letters[0].y},
        duration: 500,
        ease:Phaser.Math.Easing.Quadratic.Out,
        alpha:{start:1,to:1},
        onStart:()=>{
            //console.log(each*-100);
            letters[0].setAlpha(1);
            setTimeout(()=>{
                scene.custSound.playSoundCustom(sKey._same_letters_fall);
            },100);
            setTimeout(()=>{
                scene.custSound.playSoundCustom(sKey._same_different);
            },175);
        }
    });
    for(let c = 1; c < letters.length;c++)
    {
        timeline.add({
            targets:letters[c],
            offset:`-=${300}`,
            y: {start:"-=800", to: letters[c].y},
            duration: 500,
            ease:Phaser.Math.Easing.Quadratic.Out,
            alpha:{start:1,to:1},
            onStart:()=>{
                //console.log(each*-100);
                letters[c].setAlpha(1);
            }
        });
    }
}

export function differentFadeIn(letters,timeline)
{
    timeline.add({
        targets:letters[0],
        offset:`-=${500}`,
        y: {start:"+=1000", to: letters[0].y-10},
        duration: 500,
        ease:Phaser.Math.Easing.Quadratic.Out,
        alpha:{start:1,to:1},
        onStart:()=>{
            //console.log(c*-100);
            letters[0].setAlpha(1);
            setTimeout(()=>{
                letters[0].scene.custSound.playSoundCustom(sKey._different_letters_rise);
            },100);
        }
    });

    timeline.add({
        targets:letters[0],
        offset:`-=${10}`,
        y: letters[0].y+10,
        duration: 100,
        ease:Phaser.Math.Easing.Quadratic.Out,
        alpha:{start:1,to:1},
        onStart:()=>{
            //console.log(c*-100);
            letters[0].setAlpha(1)
        }
    })
    for(let c = 1; c < letters.length;c++)
    {
        timeline.add({
            targets:letters[c],
            offset:`-=${500}`,
            y: {start:"+=1000", to: letters[c].y-10},
            duration: 500,
            ease:Phaser.Math.Easing.Quadratic.Out,
            alpha:{start:1,to:1},
            onStart:()=>{
                //console.log(c*-100);
                letters[c].setAlpha(1)
            }
        });

        timeline.add({
            targets:letters[c],
            offset:`-=${10}`,
            y: letters[c].y+10,
            duration: 100,
            ease:Phaser.Math.Easing.Quadratic.Out,
            alpha:{start:1,to:1},
            onStart:()=>{
                //console.log(c*-100);
                letters[c].setAlpha(1)
            }
        })
    }
}
function shadowFadeIn(objects,timeline)
{
    timeline.add({
        targets:objects,
        offset:`-=${10}`,
        //y: "-=82",
        alpha:{start:0,to:1},
        duration: 500,
        ease:Phaser.Math.Easing.Quadratic.InOut,
    });
}

function raiseAll(objects,play,timeline)
{
    timeline.add({
        targets:objects,
        offset:`-=${10}`,
        y: "-=82",
        duration: 500,
        ease:Phaser.Math.Easing.Quadratic.InOut,
    });

    let Rotation;
    let Distance;

    Distance = 6.283 * play.width/2;
    Rotation = Distance/(play.width/2);

    timeline.add({
        targets:play,
        offset:`-=${500}`,
        alpha:{start:1,to:1},
        y: {start:play.y + Distance, to: play.y},
        rotation: Rotation,
        duration: 500,
        ease:Phaser.Math.Easing.Quadratic.InOut,
        onStart:()=>{
            play.setAlpha(1);
            play.setInteractive();
            setUpPlayButton(play,objects);
            play.scene.custSound.playSoundCustom(sKey._play_button_pop_up);
        }
    });
}